import { LitElement, customElement, html, property } from 'lit-element';

/**
 * LitElement
 * A simple base class for creating fast, lightweight web components.
 *
 * @docs https://lit-element.polymer-project.org/
 */
/**
 * Custom input-button for unique cases in web-app
 */
@customElement('custom-form-input-button')
class CustomFormInputButtonComponent extends LitElement {
  /* eslint-disable camelcase */
  @property({ type: String })
  id;

  @property({ type: String })
  field_name;

  @property({ type: String })
  field_value;

  @property({ type: String })
  content_key;

  @property({ type: String })
  type = 'button';

  @property({ type: Object })
  disabled = false;

  @property({ type: String })
  request_item_id;

  @property({ type: String })
  loading_indicator_field = 'is_item_loading';

  connectedCallback() {
    super.connectedCallback();

    if (this.id && typeof this.id !== 'string') {
      throw new Error(
        "`id` must be a `string` if it's defined in `custom-form-input-button` component.",
      );
    }

    if (!this.field_name || typeof this.field_name !== 'string') {
      throw new Error(
        '`field_name` must be a `string` and must be defined in `custom-form-input-button` component.',
      );
    }

    if (!this.field_value || typeof this.field_value !== 'string') {
      throw new Error(
        '`field_value` must be a `string and must be defined` in `custom-form-input-button` component.',
      );
    }

    if (!this.content_key || typeof this.content_key !== 'string') {
      throw new Error(
        '`content_key` must be a `string` and must be defined in `custom-form-input-button` component.',
      );
    }

    if (this.request_item_id && typeof this.request_item_id !== 'string') {
      throw new Error(
        "`request_item_id` must be a `string` if it's defined in `custom-form-input-button` component.",
      );
    }

    if (!this.loading_indicator_field || typeof this.loading_indicator_field !== 'string') {
      throw new Error(
        '`loading_indicator_field` must be a `string` and must be defined in `custom-form-input-button` component.',
      );
    }

    const types = ['button', 'submit'];
    if (!types.includes(this.type)) {
      this.type = 'button';
    }
  }

  render() {
    const disabled = this.kasko.evaluateJsonLogic(this.disabled?.schema || this.disabled);

    return html`
      <div class="form-group btn-next-centered">
        <button
          class="btn btn-block btn-primary d-flex"
          id=${this.id ? this.id : ''}
          type="button"
          ?disabled=${!!disabled}
          @click=${this.onClick}
        >
          <span class="adjust-broken-white-space-form-input-button no-margin">
            ${this.kasko.getTranslation(this.content_key)}
          </span>
        </button>
      </div>
    `;
  }

  onClick() {
    this.kasko.dispatchEvent('set-state-input', {
      [this.field_name]: this.field_value,
      [this.loading_indicator_field]: !!this.request_item_id,
    });

    if (this.request_item_id) {
      this.kasko.dispatchEvent('request-item', {
        item_id: this.request_item_id,
      });
    }

    if (this.type === 'submit') {
      this.kasko.dispatchEvent('go-forward');
    }
  }

  createRenderRoot() {
    return this;
  }
}

export default CustomFormInputButtonComponent;
